import gql from "graphql-tag";

// aceptacion de la version vigente de los T&C por el usuario del token
const acceptTnCUpdate = gql`
  mutation acceptTnCUpdate {
    AcceptTnCUpdate: acceptTnCUpdate {
      message
      motive
      statusCode
    }
  }
`;

export { acceptTnCUpdate };
